import React from 'react';
import { CleaningPeriod, weekLabel } from './cleaningWeek';

// 📅 Κοινό UI φίλτρου περιόδου (CleaningDashboard + CleaningJobsAdmin).
// Δύο modes: εβδομάδα (◀ τρέχουσα ▶) ή εύρος ημερομηνιών (από→έως, για παλιότερα).
interface Props {
  period: CleaningPeriod;
  now: Date;
  onChange: (p: CleaningPeriod) => void;
}

const CleaningPeriodFilter: React.FC<Props> = ({ period, now, onChange }) => {
  const isWeek = period.mode === 'week';
  const offset = isWeek ? (period as any).offset : 0;
  const from = !isWeek ? (period as any).from : '';
  const to = !isWeek ? (period as any).to : '';

  return (
    <div className="flex flex-wrap items-center gap-2 mb-3 p-2 bg-white/70 rounded-lg text-sm">
      {isWeek ? (
        <div className="flex items-center gap-1">
          <button onClick={() => onChange({ mode: 'week', offset: offset - 1 })}
            className="px-2 py-1 rounded bg-white border border-gray-300 text-gray-700 hover:bg-gray-100" title="Προηγούμενη εβδομάδα">◀</button>
          <span className="px-2 py-1 font-semibold text-gray-700 min-w-[9rem] text-center">
            {offset === 0 ? '📅 Τρέχουσα εβδομάδα' : weekLabel(now, offset)}
          </span>
          <button onClick={() => onChange({ mode: 'week', offset: offset + 1 })}
            className="px-2 py-1 rounded bg-white border border-gray-300 text-gray-700 hover:bg-gray-100" title="Επόμενη εβδομάδα">▶</button>
        </div>
      ) : (
        <div className="flex items-center gap-1">
          <input type="date" value={from}
            onChange={e => onChange({ mode: 'range', from: e.target.value, to })}
            className="px-2 py-1 border border-gray-300 rounded" />
          <span className="text-gray-400">→</span>
          <input type="date" value={to}
            onChange={e => onChange({ mode: 'range', from, to: e.target.value })}
            className="px-2 py-1 border border-gray-300 rounded" />
        </div>
      )}
      <button onClick={() => onChange(isWeek ? { mode: 'range', from: '', to: '' } : { mode: 'week', offset: 0 })}
        className="px-3 py-1 rounded bg-blue-100 text-blue-700 font-semibold hover:bg-blue-200">
        {isWeek ? '🗓️ Επιλογή ημ/νιών' : '↺ Τρέχουσα εβδομάδα'}
      </button>
    </div>
  );
};

export default CleaningPeriodFilter;
